import { render, staticRenderFns } from "./AppFigure.vue?vue&type=template&id=1afeb847&scoped=true"
import script from "./AppFigure.vue?vue&type=script&lang=ts"
export * from "./AppFigure.vue?vue&type=script&lang=ts"
import style0 from "./AppFigure.vue?vue&type=style&index=0&id=1afeb847&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afeb847",
  null
  
)

export default component.exports